module.exports = __webpack_public_path__ + "img/97-611347.png";